import { FlowbiteButtonInnerTheme } from 'flowbite-react';
import { DeepPartial } from 'flowbite-react/lib/esm/types';

export interface ButtonGroupThemeProps {
    base: string;
    inner?: DeepPartial<FlowbiteButtonInnerTheme>;
}

export const buttonGroupTheme: ButtonGroupThemeProps = {
    base: 'inline-flex items-center justify-center disabled:opacity-50 gap-0 focus:outline-none focus:ring-0',
    inner: {
        base: 'border-2 border-system-outline',
    },
};
